/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var EXAM_LATERALITY_ENUM;
(function (EXAM_LATERALITY_ENUM) {
    EXAM_LATERALITY_ENUM["NEUTRAL"] = "neutral";
    EXAM_LATERALITY_ENUM["LEFT"] = "left";
    EXAM_LATERALITY_ENUM["RIGHT"] = "right";
})(EXAM_LATERALITY_ENUM || (EXAM_LATERALITY_ENUM = {}));
